var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 130,
    viewBox: "0 0 125 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.175 14.5591C59.9389 7.49664 70.0611 7.49664 73.825 14.5591L109.126 80.7968C112.676 87.4578 107.849 95.5 100.301 95.5H29.6993C22.1515 95.5 17.3245 87.4578 20.8744 80.7968L56.175 14.5591Z",
    fill: "#FCD5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0045 53H49V76.125H40.0045V53ZM40 80.75H48.9955V90H40V80.75Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3267 24.9943C50.6875 21.914 47.4938 20 43.9987 20C40.5036 20 37.3099 21.914 35.6707 24.999L1.10586 90.1927C0.338853 91.6244 -0.0410849 93.2309 0.00352035 94.8539C0.0481256 96.4768 0.515732 98.0602 1.36022 99.4477C2.19254 100.841 3.37457 101.994 4.78961 102.793C6.20466 103.591 7.80379 104.007 9.42912 104H78.5683C81.9033 104 84.9226 102.298 86.6419 99.4477C87.485 98.0597 87.9519 96.4765 87.9965 94.8538C88.0411 93.2311 87.6619 91.6248 86.8963 90.1927L52.3267 24.9943ZM9.42912 94.5945L43.9987 29.4007L78.5918 94.5945H9.42912Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationError);
export default __webpack_public_path__ + "static/media/verification-error.214763b5fcf4af43b9a4c93f0ea9e774.svg";
export { ForwardRef as ReactComponent };